import {FormControl, TabProps, Tabs} from 'platform/components';

import {RefObject, useState} from 'react';
import {UseFormReturn, useWatch} from 'react-hook-form';

import {GetSalesPlatformsApiRes} from '@dms/api/sales';

import {DescriptionGeneratorInputs} from '../types/DescriptionGeneratorInputs';
import {GeneralSettingsFormValues} from '../types/GeneralSettingsFormValues';
import {getLanguageIcon} from '../utils/getLanguageIcon';
import {LanguageTabContent} from './LanguageTabContent';

interface MultiLanguageContentSectionProps {
  control: FormControl<GeneralSettingsFormValues>;
  enabledLanguages: Array<{value: string; label: string}>;
  vehicleId: string;
  isDisabled: boolean;
  platforms: GetSalesPlatformsApiRes | undefined;
  formApi: UseFormReturn<GeneralSettingsFormValues>;
  descriptionGeneratorInputsRef: RefObject<DescriptionGeneratorInputs | null>;
}

export function MultiLanguageContentSection(props: MultiLanguageContentSectionProps) {
  const firstLanguage = props.enabledLanguages[0]?.value ?? '';
  const [activeLanguage, setActiveLanguage] = useState(firstLanguage);

  const localizedContent = useWatch({
    name: 'localizedContent',
    control: props.control,
  });

  const tabs: TabProps[] = props.enabledLanguages.map((lang) => ({
    id: lang.value,
    title: lang.label,
    icon: getLanguageIcon(localizedContent, lang.value),
    content: (
      <LanguageTabContent
        languageCode={lang.value}
        control={props.control}
        vehicleId={props.vehicleId}
        isDisabled={props.isDisabled}
        platforms={props.platforms}
        formApi={props.formApi}
        descriptionGeneratorInputsRef={props.descriptionGeneratorInputsRef}
      />
    ),
  }));

  return (
    <Tabs
      variant="condensed"
      tabs={tabs}
      activeTabId={activeLanguage}
      onChange={setActiveLanguage}
      isLazy
    />
  );
}
